<template>
  <input
    class="default-input"
    :placeholder="get_placeholder"
    :required="required"
    :type="type"
    :value="value"
    :name="name"
    :title="get_placeholder"
    @input="$emit('input', $event.target.value)"/>
</template>

<script>
export default {
  name: 'DefaultInput',
  props: {
    value: {
      required: true
    },
    placeholder: {
      type: String,
      default: ','
    },
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    get_placeholder() {
      if (this.required) {
        return `${this.placeholder}*`
      }
      return this.placeholder
    }
  }
}

</script>
